import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type UnreadNotificationsCountQueryVariables = Types.Exact<{ [key: string]: never }>

export type UnreadNotificationsCountQuery = { unreadNotificationsCount: number }

export const UnreadNotificationsCountDocument = gql`
  query unreadNotificationsCount {
    unreadNotificationsCount
  }
`

/**
 * __useUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadNotificationsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UnreadNotificationsCountQuery,
    UnreadNotificationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(
    UnreadNotificationsCountDocument,
    options
  )
}
export function useUnreadNotificationsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnreadNotificationsCountQuery,
    UnreadNotificationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(
    UnreadNotificationsCountDocument,
    options
  )
}
export function useUnreadNotificationsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UnreadNotificationsCountQuery,
        UnreadNotificationsCountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UnreadNotificationsCountQuery,
    UnreadNotificationsCountQueryVariables
  >(UnreadNotificationsCountDocument, options)
}
export type UnreadNotificationsCountQueryHookResult = ReturnType<
  typeof useUnreadNotificationsCountQuery
>
export type UnreadNotificationsCountLazyQueryHookResult = ReturnType<
  typeof useUnreadNotificationsCountLazyQuery
>
export type UnreadNotificationsCountSuspenseQueryHookResult = ReturnType<
  typeof useUnreadNotificationsCountSuspenseQuery
>
export type UnreadNotificationsCountQueryResult = Apollo.QueryResult<
  UnreadNotificationsCountQuery,
  UnreadNotificationsCountQueryVariables
>
